import { useCallback } from 'react';

const DEFAULT_ITEMS = [
  'cut',
  'copy',
  'copyWithHeaders',
  'copyWithGroupHeaders',
  'paste'
]

export default function useContextMenu() {
  return useCallback((params)=>{
    return DEFAULT_ITEMS
  }, []);
}
